import { render } from "./CharmCompTab.vue?vue&type=template&id=39c7de3a"
import script from "./CharmCompTab.vue?vue&type=script&lang=js"
export * from "./CharmCompTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__